import base_config from "./base_config";

const gamma_config = {
  ...base_config,
  STAGE: "gamma",
  ACCOUNT: "991246619886",
  AUTH_PROVIDER: 'AmazonFederate',  // Migrated LASSO -> IdPrism (Phase II, P504206896)
  // Amplify config for cognito - use getter to ensure runtime evaluation
  get AMPLIFY_CONFIG(): any {
    return {
      aws_project_region: base_config.REGION,
      aws_cognito_region: base_config.REGION,
      aws_user_pools_id: "us-west-2_B2zOvYELV",
      aws_user_pools_web_client_id: "55jcfiqkus4d0itmomncbnfkgn",
      oauth: {
        domain: "msaservice-gamma.auth.us-west-2.amazoncognito.com",
        scope: base_config.TOKEN_SCOPES_ARRAY,
        redirectSignIn: base_config.CALL_BACK_URL,
        redirectSignOut: 'https://gamma.goh.lab126.amazon.dev/',
        responseType: base_config.OAUTH_RESPONSE_TYPE,
      },
    };
  },

  // API Gateway Base URL
  BASE_URL: "https://api.gamma.msa.lab126.amazon.dev",
};

export default gamma_config;
